document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-hf-menu-toggle]');
  const menu = document.getElementById('HydraflowNavigation');
  if (!toggle || !menu) return;
  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    menu.dataset.open = String(open);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
      toggle.setAttribute('aria-expanded', 'false');
      menu.dataset.open = 'false';
      toggle.focus();
    }
  });
});

(() => {
  const initializeContactForms = (root) => {
    root.querySelectorAll('form').forEach(form => {
      const topic = form.querySelector('[data-inquiry-topic]');
      const retail = form.querySelector('[data-retail-fields]');
      if (!topic || !retail || form.dataset.contactInitialized) return;
      form.dataset.contactInitialized = 'true';
      const params = new URLSearchParams(window.location.search);
      if (params.get('inquiry') === 'retail' || window.location.pathname.endsWith('/become-a-hydraflow-partner') || params.get('view') === 'partner-preview') {
        topic.value = 'Retail partnership';
      }
      const update = () => {
        const isRetail = topic.value === 'Retail partnership';
        retail.hidden = !isRetail;
        retail.disabled = !isRetail;
        retail.querySelectorAll('input, select, textarea').forEach(input => {
          input.disabled = !isRetail;
          input.required = isRetail && input.hasAttribute('data-retail-required');
        });
      };
      topic.addEventListener('change', update);
      form.addEventListener('reset', () => requestAnimationFrame(update));
      update();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeContactForms(document));
  } else {
    initializeContactForms(document);
  }
  document.addEventListener('shopify:section:load', event => initializeContactForms(event.target));
})();
